import type { WazuhWindowsEventData } from 'src/types/mindtime/wazuhWindowsEvent';
import type { EdrDetailKeyValue } from './edrDetailSections';

/** Flat evidence fields shared by MITRE technique + Threat Hunting finding detail. */
export type EdrDetectionEvidenceFields = {
  process?: string | null;
  commandLine?: string | null;
  parentProcess?: string | null;
  executionPath?: string | null;
  sourceIp?: string | null;
  user?: string | null;
};

export type EdrDetectionDetailsFields = {
  id?: string;
  _id?: string;
  wazuhAlertId?: string | null;
  ruleId?: string | null;
  ruleLevel?: number | null;
  decoder?: string | null;
  location?: string | null;
  wazuhAgentId?: string | null;
  agentIp?: string | null;
  data?: WazuhWindowsEventData | null;
};

export const getWindowsEventMessage = (data?: WazuhWindowsEventData | null): string =>
  data?.win?.system?.message?.trim() || '';

export const getWindowsEventId = (data?: WazuhWindowsEventData | null): string =>
  data?.win?.system?.eventID?.trim() || '';

export const buildDetectionEvidenceRows = (
  item: EdrDetectionEvidenceFields
): EdrDetailKeyValue[] => {
  const rows: EdrDetailKeyValue[] = [
    { label: 'Process', value: item.process?.trim(), mono: true },
    { label: 'Command Line', value: item.commandLine?.trim(), mono: true },
    { label: 'Parent Process', value: item.parentProcess?.trim(), mono: true },
    { label: 'Execution Path', value: item.executionPath?.trim(), mono: true },
    { label: 'Source IP', value: item.sourceIp?.trim(), mono: true },
    { label: 'User', value: item.user?.trim(), mono: true },
  ];
  return rows.filter((row) => row.value != null && row.value !== '');
};

export const buildDetectionDetailsRows = (
  item: EdrDetectionDetailsFields,
  detectionId: string
): EdrDetailKeyValue[] => [
  { label: 'Detection ID', value: detectionId || '—', mono: true },
  { label: 'Alert ID', value: item.wazuhAlertId?.trim() || '—', mono: true },
  { label: 'Rule ID', value: item.ruleId?.trim() || '—', mono: true },
  {
    label: 'Rule Level',
    value: typeof item.ruleLevel === 'number' ? String(item.ruleLevel) : '—',
  },
  { label: 'Decoder', value: item.decoder?.trim() || '—' },
  { label: 'Location', value: item.location?.trim() || '—' },
  { label: 'Agent ID', value: item.wazuhAgentId?.trim() || '—', mono: true },
  { label: 'Agent IP', value: item.agentIp?.trim() || '—', mono: true },
  { label: 'Event ID', value: getWindowsEventId(item.data) || '—', mono: true },
];
